module.exports = __webpack_public_path__ + "acoperis-bg.jpg?3ab7e5419bc767c34cd43805a3917cdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/acoperis-bg.jpg
// module id = 139
// module chunks = 0